import { getLeftPositionInPercentage } from './getLeftPositionInPercentage';
import { getWidthInPercentage } from './getWidthInPercentage';

export const getFinalPrepIntervOperGapData = (activeMonths: Date[], date1: Date, date2: Date) => {
  const widthInPercentageGap = getWidthInPercentage(activeMonths, date1, date2);
  const leftPositionInPercentageGap = getLeftPositionInPercentage(activeMonths, date1);
  const daysDifferenceGap = Math.ceil((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));

  return { widthInPercentageGap, leftPositionInPercentageGap, daysDifferenceGap };
};
